var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#85A5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 18.1836V22.9094C13 23.557 13.536 24.0885 14.1836 24.0885H44.9088C45.5564 24.0885 46.0925 23.557 46.0925 22.9094V18.1836C46.0925 17.536 45.5564 17 44.9088 17H14.1836C13.536 17 13 17.536 13 18.1836ZM27.9051 21.7256H15.363V19.3628H27.9051V21.7256Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 27.6347V32.3604C13 33.0081 13.536 33.5441 14.1836 33.5441H44.9088C45.5564 33.5441 46.0925 33.008 46.0925 32.3649V27.6347C46.0925 26.9916 45.5564 26.4555 44.9088 26.4555H14.1836C13.536 26.4555 13 26.9916 13 27.6347ZM36.7221 31.1813H15.363V28.8184H36.7221V31.1813Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 37.0906V41.8163C13 42.4639 13.536 42.9999 14.1836 42.9999H44.9088C45.5564 42.9999 46.0925 42.4639 46.0925 41.8163V37.0906C46.0925 36.443 45.5564 35.907 44.9088 35.907H14.1836C13.536 35.907 13 36.443 13 37.0906ZM31.2054 40.6371H15.363V38.2698H31.2054V40.6371Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignTask);
export default __webpack_public_path__ + "static/media/design-task.8dc74ac47bdcc50ba888e1fa738b260a.svg";
export { ForwardRef as ReactComponent };